import { render, staticRenderFns } from "./OmniCheckboxes.vue?vue&type=template&id=53cf79ab&"
import script from "./OmniCheckboxes.vue?vue&type=script&lang=js&"
export * from "./OmniCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./OmniCheckboxes.vue?vue&type=style&index=0&id=53cf79ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports